import React, {FC} from "react";
import Link from "next/link";
import {ArrowRoundedRight6x9Svg} from "../../svg";
import {useSelector} from "react-redux";
import {UrlObject} from "url";
import {IState} from "../../types/state";
import {ReactNodeArray} from "prop-types";
import {useRouter} from "next/router";
import cls from "./shared.module.scss"
import Script from "next/script";
import {schemaPageHeader} from "../schemaorg";

interface IProps {
    breadcrumb: Array<{
        title: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | React.ReactFragment | null | undefined;
        url: string | UrlObject;
    }> | any,
    header?: JSX.Element | ReactNodeArray,
    dbName: string,
}

const PageHeader: FC<IProps> = (props) => {
    let {breadcrumb = [], dbName} = props;
    const router = useRouter();
    const schema = schemaPageHeader(dbName, router.asPath, breadcrumb)

    if (breadcrumb.length > 0) {
        const lastIndex = breadcrumb.length - 1;

        breadcrumb = breadcrumb.map((item: {
            title: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | React.ReactFragment | null | undefined;
            url: string | UrlObject;
        }, index: React.Key | null | undefined) => {
            let link;
            if (lastIndex === index) {
                link = (
                    <React.Fragment key={index}>
                        <Script
                            id={schema.name}
                            type="application/ld+json"
                            dangerouslySetInnerHTML={{__html: JSON.stringify(schema)}}
                        />
                        <li
                            className={`${cls["breadcrumb-item"]} ${cls["breadcrumb-item-active"]}`}
                            aria-current="page"
                        >
                            {item.title}
                        </li>
                    </React.Fragment>
                );
            } else {
                link = (
                    <li key={index} className={cls["breadcrumb-item"]}>
                        <Link href={item.url}>
                            <a>
                                {item.title}
                            </a>
                        </Link>
                        <ArrowRoundedRight6x9Svg className={cls["breadcrumb-arrow"]}/>
                    </li>
                );
            }
            return link;
        });

        breadcrumb = (
            <div className={cls["page-header__breadcrumb"]}>
                <nav aria-label="breadcrumb">
                    <ol className={cls["breadcrumb"]}>{breadcrumb}</ol>
                </nav>
            </div>
        );
    }

    return (
        <div className={cls["page-header"]}>
            <div className={`${cls["page-header__container"]} container`}>
                {breadcrumb}
            </div>
        </div>
    );
}

export default PageHeader;
